// extracted by mini-css-extract-plugin
module.exports = {"body":"ClampedNote_body__M2VxE","expanded":"ClampedNote_expanded__1gBdq","toggle":"ClampedNote_toggle__Ze_aR"};